import { useEffect, useRef, useState, useCallback } from 'react';

/**
 * Detects if an element's content is overflowing vertically.
 *
 * @param {Array} deps - optional dependency array (e.g. [items.length])
 */
export default function useIsOverflowing(deps = []) {
    const ref = useRef(null);
    const [isOverflowing, setIsOverflowing] = useState(false);

    const checkOverflow = useCallback(() => {
        const el = ref.current;
        if (!el) return;
        setIsOverflowing(el.scrollHeight > el.clientHeight);
    }, []);

    useEffect(() => {
        const el = ref.current;
        if (!el) return;

        const timeout = setTimeout(checkOverflow, 0);
        window.addEventListener('resize', checkOverflow);

        return () => {
            clearTimeout(timeout);
            window.removeEventListener('resize', checkOverflow);
        };
    }, [checkOverflow, ...deps]);

    return { ref, isOverflowing, checkOverflow };
}
